export type LegacyHomeTarget =
  | { kind: "dashboard" }
  | { kind: "navigate"; to: string }
  | { kind: "none" };

/**
 * Destino de Home por display name legacy.
 * La autorización real sigue en el backend.
 */
export function legacyHomeTarget(
  rol: string | null | undefined,
): LegacyHomeTarget {
  if (rol === "Contador") {
    return { kind: "navigate", to: "colaboradores" };
  }

  if (
    rol === "Administrador" ||
    rol === "Talento humano" ||
    rol === "Reclutador" ||
    rol === "Administrador-" ||
    rol === "Lider de sucursal"
  ) {
    return { kind: "dashboard" };
  }

  if (rol === "Reclutamiento") {
    return { kind: "navigate", to: "/vacantes" };
  }

  if (rol === "Trabajador") {
    return { kind: "navigate", to: "mi-expediente" };
  }

  if (rol === "Reclutador/Archivos") {
    return { kind: "navigate", to: "solicitudes" };
  }

  if (rol === "Reloj checador") {
    return { kind: "navigate", to: "reloj-checador" };
  }

  if (rol === "Capacitación y Cultura") {
    return { kind: "navigate", to: "birthdates" };
  }

  if (rol === "Líder de líderes") {
    return { kind: "navigate", to: "sucursales" };
  }

  return { kind: "none" };
}
